import environment from 'environment';
import { getRequest } from '..';

const { REVOLVE_BASE_URL } = environment.eCommerce;

export const revolveGetQuery = getRequest(REVOLVE_BASE_URL, {
  response: 180000, // Wait 180 seconds for the server to start sending,
  deadline: 240000, // but allow 240 seconds for the server to respond
});
